<!-- @format -->
<script>
export default {
  props: {
    title: { type: String, required: true },
    text: { type: String, default: "" },
  },
};
</script>

<template>
  <div class="empty" role="status" aria-live="polite">
    <span class="empty__icon icons-search font-24" aria-hidden="true"></span>
    <p class="empty__title font-16 font-600 font-strong">{{ title }}</p>
    <p v-if="text" class="empty__text font-14 font-400 font-subtle">{{ text }}</p>
  </div>
</template>

<style scoped lang="scss">
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--space-8);
  padding: var(--space-24) var(--space-16);

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin-bottom: var(--space-4);
    border-radius: 50%;
    background-color: var(--bg-level2);
    color: var(--text-subtle);
  }

  &__title {
    margin: 0px;
  }

  &__text {
    margin: 0px;
    max-width: 300px;
  }
}
</style>
